import mdl from '@/models/Accounting/AccAccountingSeatType'

const getAllTypes = async () => {
    try {
        let response = await mdl.params({ get_all_results: true }).get()
        return response
    } catch (error) {
        return error.response
    }
}

export { getAllTypes }
